<template>
	<TheTable
		v-if="tableData"
		:tableData="tableData"
		:loading="loading"
		:defaultSort="{ prop: 'createdDate', order: 'descending' }"
		:showMaxRows="14"
		@rowClick="goToDetailPage"
		@rowClickNewTab="goToDetailPageNewTab"
		:mobileBox="mobileBox"
	>
		<template #box>
			<BoxComplaintPublic v-for="item in tableData" :key="item.id" :complaint="item" />
		</template>

		<el-table-column prop="publishedDate" label="Datum" width="130" sortable>
			<template #default="scope">
				<span>{{ $formatDate(scope.row.publishedDate) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="title" label="Titel" min-width="250" sortable :sort-method="(a, b) => $sortAlphabetically(a, b, 'title')" />
		<el-table-column prop="medium" label="Medium" width="200" sortable>
			<template #default="scope">
				<span v-if="scope.row.medium?.name">{{ scope.row.medium.name }}</span>
				<span v-else>-</span>
			</template>
		</el-table-column>

		<el-table-column prop="category" label="Beschwerdegrund" width="200" sortable>
			<template #default="scope">
				<span v-if="scope.row.category">{{ $recursivelyFindCategoryName(scope.row.category.number) }}</span>
				<span v-else>-</span>
			</template>
		</el-table-column>
	</TheTable>

	<TablePagination :currentLength="tableData.length" :totalMaxVal="totalCount" @loadNextPage="$emit('loadNextPage')" />
</template>

<script lang="ts">
import { Paperclip } from '@element-plus/icons-vue';
import { defineComponent, PropType } from 'vue';
import { ComplaintPublicResponse } from '../../types/types';
import TheTable from '../TheTable.vue';
import TablePagination from './TablePagination.vue';
import BoxComplaintPublic from '../boxes/BoxComplaintPublic.vue';

export default defineComponent({
	name: 'PublicComplaintsTable',
	components: {
		Paperclip,
		TablePagination,
		TheTable,
		BoxComplaintPublic,
	},
	props: {
		tableData: {
			type: Array as PropType<ComplaintPublicResponse[]>,
			default: [],
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		totalCount: {
			type: Number,
			default: 0,
		},
		mobileBox: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	emits: ['loadNextPage'],
	methods: {
		goToDetailPage(row: ComplaintPublicResponse) {
			this.$router.push({ name: 'BeschwerdeDetail', params: { id: String(row.id) } });
		},
		goToDetailPageNewTab(row: ComplaintPublicResponse) {
			window.open(this.$router.resolve({ name: 'BeschwerdeDetail', params: { id: String(row.id) } }).href, '_blank');
		},
	},
});
</script>
